var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarReprovacao()}}},[_c('span',[_c('i',{staticClass:"fa fa-ban mr-2"}),_vm._v(" Reprovar ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }